import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TaskService } from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UUID } from 'angular2-uuid';

@Component({
  selector: 'app-warned',
  templateUrl: './warned.component.html',
  styleUrls: ['./warned.component.css']
})
export class WarnedComponent implements OnInit {
  canOprate = true; // 能否操作
  validateForm = this.fb.group({
    name: '', // 模板名称
    noticeType: ['', Validators.required], // 提醒类型
    noticeTypeText: [''], // 提醒类型转义字段
    noticeMoment: ['', Validators.required],
    noticeMomentText: [''], // 提醒时点转义字段
    schedulerDescription: ['', Validators.required], // 定时提醒时间
    schedule: [null], // 定时提醒时间
    subject: [''], // 主题
    body: [''], // 内容
  });
  fileList = [];
  // 收件人对应参数
  allUserOption = []; // 全部用户
  userOption = []; // 过滤后的用户
  userValue = '';

  allRoleOption = []; // 全部角色
  roleOption = []; // 过滤后的角色
  roleValue = '';

  allVariableOption = []; // 全部变量
  variableOption = []; // 过滤后胡变量
  variableValue = '';

  addType = ''; // 类型，ccRecipient - 抄送人, recipient - 收件人

  // 提醒类型
  noticeTypeList = [
    {
      value: 'email',
      name: '邮件'
    }
  ];

  // 提醒时点
  noticeMomentList = [
    {
      value: 'afterDone',
      name: '扫描完成后'
    },
    {
      value: 'cron',
      name: '定时提醒'
    }
  ]

  // 收件人
  recipient = {
    users: [],
    roles: [],
    variables: [
    ],
    addresses: []
  };
  inputValue = '';

  // 抄送人
  ccRecipient  = {
    users: [],
    roles: [],
    variables: [],
    addresses: []
  };
  carbonList = [
  ];
  carbonValue = '';


  // 主题对应参数
  subjectLabels = [];
  bodyLabels = [];
  selectionStart = 1;

  // 邮件内容数据列表
  emailList = [];
  checkedEmailList = [];
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭

  sendFlag = false; // 是否发送提醒
  emailTemplateList = []; // 邮件模板

  // 编辑列表数据
  editListVisible = false;
  viewHead: any = [];
  viewTableData: any = [];

  // 添加数据列
  addDataVisible = false;
  addDataForm = this.fb.group({
    name: ['', Validators.required]
  });

  // 编辑列表数据
  viewTableWidth = 400;

  executionId = ''; // 执行id
  ids: [];

  selfDefValue = []; // 编辑列表数据-添加数据列自定义数据

  @Input('isSendWarned') set getSend(val) {
    this.sendFlag = val;
    if (val) {
      this.validateForm = this.fb.group({
        noticeType: ['', Validators.required], // 提醒类型
        noticeTypeText: [''], // 提醒类型转义字段
        emailModel: [''], // 邮件模板
        emailModelText: [''], // 邮件模板转义字段
        subject: [''], // 主题
        body: [''], // 内容
      });
    }
  };
  constructor(
    private fb: FormBuilder,
    private supService: TaskService,
    private message: NzMessageService,
    private modalServer: NzModalService,
  ) { }

  ngOnInit(): void {
  }

  getEmailTemplate(itemId) {
    this.emailTemplateList = [];
    this.supService.getEmailTemplateList(itemId).subscribe( (res: any) => {
      this.emailTemplateList = res ? res : [];
    });
  }

  getList(id) {
    this.supService.getGroupField(id).subscribe( (res: any) => {
      this.fileList = res ? res : [];
      this.emailList = JSON.parse(JSON.stringify(this.fileList));
      this.allVariableOption = JSON.parse(JSON.stringify(this.fileList));
      this.variableOption = this.allVariableOption;
    })

    this.supService.getUserList().subscribe( (res: any) => {
      const data = res ? res : [];
      this.allUserOption = [];
      data.forEach( item => {
        const obj = {
          code: item.userId,
          name: item.cn
        }
        this.allUserOption.push(obj);
      });
      this.userOption = this.allUserOption;
    })
    this.supService.getRoleList().subscribe( (res: any) => {
      this.allRoleOption = res ? res : [];
      this.roleOption = this.allRoleOption;
    })
  }

  getOutIndicatorList(columns) {
    this.fileList = columns && columns.length > 0 ? columns : [];
    this.emailList = JSON.parse(JSON.stringify(this.fileList));
    this.allVariableOption = JSON.parse(JSON.stringify(this.fileList));
    this.variableOption = this.allVariableOption;

    this.supService.getUserList().subscribe( (res: any) => {
      const data = res ? res : [];
      this.allUserOption = [];
      data.forEach( item => {
        const obj = {
          code: item.userId,
          name: item.cn
        }
        this.allUserOption.push(obj);
      });
      this.userOption = this.allUserOption;
    });
    this.supService.getRoleList().subscribe( (res: any) => {
      this.allRoleOption = res ? res : [];
      this.roleOption = this.allRoleOption;
    });
  }

  // 获取焦点
  focusHandle() {
    if (document.getElementById('reciverPerson')) {
      document.getElementById('reciverPerson').focus();
    }
  }

  // 获取焦点
  carbonFocusHandle() {
    if (document.getElementById('carbonPerson')) {
      document.getElementById('carbonPerson').focus();
    }
  }

  // 失去焦点
  inputBlurHandle() {
    if (this.inputValue && !this.recipient.addresses.filter( item => item.name === this.inputValue).length) {
      const obj = {
        name: '',
        code: ''
      }
      obj['name'] = this.inputValue;
      obj['code'] = this.inputValue;
      this.recipient.addresses.push(obj);
      this.inputValue = '';
    } else {
      this.inputValue = '';
    }
  }

  // 失去焦点
  carbonBlurHandle() {
    if (this.carbonValue && !this.ccRecipient.addresses.filter( item => item.name === this.carbonValue).length) {
      const obj = {
        name: '',
        code: ''
      }
      obj['name'] = this.carbonValue;
      obj['code'] = this.carbonValue;
      this.ccRecipient.addresses.push(obj);
      this.carbonValue = '';
    } else {
      this.carbonValue = '';
    }
  }

  getInputIndex(target) {
    setTimeout(() => {
      this.selectionStart = target.selectionStart;
    }, 50);
  }

  // 主题, tag点击事件
  columnTagClick(column, type) {
    if (type === 'subject') {
      this.insertLabel(this.validateForm.get('subject').value, this.subjectLabels, column);
      const subject = this.assembleStr(this.validateForm.get('subject').value, column, 'name');
      this.validateForm.get('subject').patchValue(subject)
    } else {
      this.insertLabel(this.validateForm.get('body').value, this.bodyLabels, column);
      const body = this.assembleStr(this.validateForm.get('body').value, column, 'name');
      this.validateForm.get('body').patchValue(body)
    }
    this.selectionStart += ('{' + column.name + '}').length;
  }

  insertLabel(target, targetArr, column) {
    if (this.selectionStart > 1) {
      const labels = [];
      for (const item of targetArr) {
        labels.push(item.title);
      }
      target = target || '';
      const matchArray = target.substring(0, this.selectionStart).match(/\{[^\{\}]+\}/g);
      let count = 0;
      if (matchArray) {
        count = matchArray.length;
        for (let i = 0; i < matchArray.length; i++) {
          if (i > labels.length || !matchArray[i].includes(labels[i])) {
            count--;
          }
        }
      }
      targetArr.splice(count, 0, column);
    } else {
      targetArr.splice(0, 0, column);
    }
  }

  assembleStr(target, column, attr) {
    if (target) {
      target = target.substring(0, this.selectionStart)
        + '{' + column[attr] + '}' + target.substring(this.selectionStart, target.length);
    } else {
      target = '{' + column[attr] + '}';
    }
    return target;
  }

  // 选中事件
  changeChcked(index) {
    this.checkedEmailList.push(this.emailList[index]);
  }

  // 删除事件
  deleteEmail(index) {
    this.checkedEmailList.splice(index ,1);
  }

  // 提醒时点-确定回掉
  getSchedulerData(event) {
    if (!this.canOprate) { return}
    this.validateForm.patchValue( {'schedulerDescription': event.text} );
    this.validateForm.patchValue( {'schedule': event.config} );
    this.schedulerConditionVisible = false;
    this.schedulerConditionData = event.config;
    this.schedulerConditionData['schedulerDescription'] =  event.text;
  }

  // 用户搜索
  filterUser() {
    if (this.userValue) {
      this.userOption = this.allUserOption.filter( item => item.name.indexOf(this.userValue) >= 0);
    } else {
      this.userOption = this.allUserOption;
    }
  }

  // 角色搜索
  filterRole() {
    if (this.roleValue) {
      this.roleOption = this.allRoleOption.filter( item => item.name.indexOf(this.roleValue) >= 0);
    } else {
      this.roleOption = this.allRoleOption;
    }

  }

  // 变量搜索
  filterVariable() {
    if (this.variableValue) {
      this.variableOption = this.allVariableOption.filter( item => item.name.indexOf(this.variableValue) >= 0);
    } else {
      this.variableOption = this.allVariableOption;
    }

  }

  addStaff(type) {
    this.addType = type;
    this.userValue = '';
    this.roleValue = '';
    this.variableValue = '';
    if (type === 'recipient') {
      this.allUserOption.forEach(item => {
        if (this.recipient.users.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
      this.allRoleOption.forEach(item => {
        if (this.recipient.roles.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
      this.allVariableOption.forEach(item => {
        if (this.recipient.variables.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
    } else {
      this.allUserOption.forEach(item => {
        if (this.ccRecipient.users.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
      this.allRoleOption.forEach(item => {
        if (this.ccRecipient.roles.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
      this.allVariableOption.forEach(item => {
        if (this.ccRecipient.variables.filter( data => data.code === item.code).length) {
          item['checked'] = true;
        } else {
          item['checked'] = false;
        }
      });
    }
    this.userOption = this.allUserOption;
    this.roleOption = this.allRoleOption;
    this.variableOption = this.allVariableOption;
  }

  // 用户选中状态变更
  userChangeChecked(event, data) {
    if (event) {
      if (this.addType === 'recipient') { // 收件人
        this.recipient.users.push(data);
      } else { // 抄送人
        this.ccRecipient.users.push(data);
      }
    } else {
      if (this.addType === 'recipient') { // 收件人
        const index = this.recipient.users.findIndex( item => item.code === data.code);
        this.recipient.users.splice(index, 1);
      } else { // 抄送人
        const index = this.ccRecipient.users.findIndex( item => item.code === data.code);
        this.ccRecipient.users.splice(index, 1);
      }
    }
  }

  // 角色选中状态变更
  roleChangeChecked(event, data) {
    if (event) {
      if (this.addType === 'recipient') { // 收件人
        this.recipient.roles.push(data);
      } else { // 抄送人
        this.ccRecipient.roles.push(data);
      }
    } else {
      if (this.addType === 'recipient') { // 收件人
        const index = this.recipient.roles.findIndex( item => item.code === data.code);
        this.recipient.roles.splice(index, 1);
      } else { // 抄送人
        const index = this.ccRecipient.roles.findIndex( item => item.code === data.code);
        this.ccRecipient.roles.splice(index, 1);
      }
    }
  }

  // 变量选中状态变更
  variableChangeChecked(event, data) {
    if (event) {
      if (this.addType === 'recipient') { // 收件人
        this.recipient.variables.push(data);
      } else { // 抄送人
        this.ccRecipient.variables.push(data);
      }
    } else {
      if (this.addType === 'recipient') { // 收件人
        const index = this.recipient.variables.findIndex( item => item.code === data.code);
        this.recipient.variables.splice(index, 1);
      } else { // 抄送人
        const index = this.ccRecipient.variables.findIndex( item => item.code === data.code);
        this.ccRecipient.variables.splice(index, 1);
      }
    }
  }

  // 删除接收人/收件人
  deleteStaff(field, type, index) {
    this[field][type].splice(index, 1);
  }

  // 提醒类型变更
  changeType(event) {
    if (event) {
      const data = this.noticeTypeList.filter( item => item.value === event);
      this.validateForm.get('noticeTypeText').patchValue(data[0].name);
    } else {
      this.validateForm.get('noticeTypeText').patchValue('');
    }
  }

  // 提醒时点变更
  changeMoment(event) {
    if (event) {
      const data = this.noticeMomentList.filter( item => item.value === event);
      this.validateForm.get('noticeMomentText').patchValue(data[0].name);
    } else {
      this.validateForm.get('noticeMomentText').patchValue('');
    }
  }

  getSubmitForm() {
    if (!this.sendFlag) { // 不是发送提醒
      if (this.validateForm.get('noticeMoment').value === 'cron') {
        this.validateForm.get('schedulerDescription').setValidators(Validators.required);
      } else {
        this.validateForm.get('schedulerDescription').clearValidators();
      }
    }
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    let recipientFlag = false;
    if (this.recipient.users && this.recipient.users.length) {
      recipientFlag = true;
    }
    if (this.recipient.roles && this.recipient.roles.length) {
      recipientFlag = true;
    }
    if (this.recipient.variables && this.recipient.variables.length) {
      recipientFlag = true;
    }
    if (this.recipient.addresses && this.recipient.addresses.length) {
      recipientFlag = true;
    }
    if (!recipientFlag) {
      this.message.warning('请选择收件人！')
      return;
    }
    if (this.validateForm.valid) {
      let subjectContent = '';
      let bodyContent = '';
      // 处理主题中包含的标签
      if (this.validateForm.get('subject').value) {
        let subject = this.validateForm.get('subject').value;
        this.fileList.forEach( (item, index) => {
          if (subject.indexOf('{' + item.name + '}') >= 0 ) {
            subject = subject.replace( RegExp('{' + item.name + '}', 'g'), '{"code":"' + item.code + '","name": "' + item.name + '"}');
          }
        });
        subjectContent = subject;
      }
      // 处理内容中包含的标签
      if (this.validateForm.get('body').value) {
        let body = this.validateForm.get('body').value;
        this.fileList.forEach( (item, index) => {
          if (body.indexOf('{' + item.name + '}') >= 0 ) {
            body = body.replace(RegExp('{' + item.name + '}', 'g'), '{"code":"' + item.code + '","name": "' + item.name + '"}')
          } else {
            this.bodyLabels.splice(index, 1);
          }
        })
        bodyContent = body;
      }
      const data = Object.assign( {},
                                  this.validateForm.value,
                                  {recipient: this.recipient},
                                  {ccRecipient: this.ccRecipient},
                                  {bodyDetail: this.checkedEmailList},
                                  {
                                    subject: {
                                      content: subjectContent,
                                      contentText: this.validateForm.get('subject').value,
                                      variable: []
                                    },
                                    body: {
                                      content: bodyContent,
                                      contentText: this.validateForm.get('body').value,
                                      variable: []
                                    }
                                  }
                                  );
      if (this.sendFlag) {
        data['selfDefValue'] = this.selfDefValue;
      }
      return data;
    } else {
      return;
    }
  }

  initWarned(data?) {
    const obj = data ? data : {};
    if (this.sendFlag) {
      if ((JSON.stringify(obj) !== '{}') && !obj.hasOwnProperty('emailModel')) { // 处理邮件模板联动不反填邮件模板
        this.validateForm.patchValue({
          noticeType: obj.noticeType ? obj.noticeType : '',
          noticeTypeText: obj.noticeTypeText ? obj.noticeTypeText : '',
          emailModelText: obj.emailModelText ? obj.emailModelText : '', // 邮件模板转义字段
          subject: obj.subject && obj.subject.contentText ? obj.subject.contentText : '',
          body: obj.body && obj.body.contentText ? obj.body.contentText : '',
        });
      } else {
        this.validateForm.patchValue({
          noticeType: obj.noticeType ? obj.noticeType : '',
          noticeTypeText: obj.noticeTypeText ? obj.noticeTypeText : '',
          emailModel: obj.emailModel ? obj.emailModel : '', // 邮件模板
          emailModelText: obj.emailModelText ? obj.emailModelText : '', // 邮件模板转义字段
          subject: obj.subject && obj.subject.contentText ? obj.subject.contentText : '',
          body: obj.body && obj.body.contentText ? obj.body.contentText : '',
        });
      }
    } else {
      this.validateForm.patchValue({
        noticeType: obj.noticeType ? obj.noticeType : '',
        noticeTypeText: obj.noticeTypeText ? obj.noticeTypeText : '',
        noticeMoment: obj.noticeMoment ? obj.noticeMoment : '',
        noticeMomentText: obj.noticeMomentText ? obj.noticeMomentText : '',
        schedule: obj.schedule ? obj.schedule : null,
        schedulerDescription: obj.schedulerDescription ? obj.schedulerDescription : '',
        subject: obj.subject && obj.subject.contentText ? obj.subject.contentText : '',
        body: obj.body && obj.body.contentText ? obj.body.contentText : '',
        name: obj.name && obj.name ? obj.name : ''
      });
      this.schedulerConditionData = data && data.schedule ? data.schedule : {};
    }
    this.recipient = {
      users: obj && obj.recipient && obj.recipient.users ? obj.recipient.users : [],
      roles: obj && obj.recipient && obj.recipient.roles ? obj.recipient.roles : [],
      variables: obj && obj.recipient && obj.recipient.variables ? obj.recipient.variables : [],
      addresses: obj && obj.recipient && obj.recipient.addresses ? obj.recipient.addresses : []
    };
    this.ccRecipient = {
      users: obj && obj.ccRecipient && obj.ccRecipient.users ? obj.ccRecipient.users : [],
      roles: obj && obj.ccRecipient && obj.ccRecipient.roles ? obj.ccRecipient.roles : [],
      variables: obj && obj.ccRecipient && obj.ccRecipient.variables ? obj.ccRecipient.variables : [],
      addresses: obj && obj.ccRecipient && obj.ccRecipient.addresses ? obj.ccRecipient.addresses : []
    };
    this.checkedEmailList = obj && obj.bodyDetail ? obj.bodyDetail : [];
  }

  // 编辑列表数据
  editListOprate() {
    this.editListVisible = true;
    this.viewHead = JSON.parse(JSON.stringify(this.checkedEmailList));
    const bodyDetail = [];
    this.checkedEmailList.forEach( item => {
      const obj = {
        code: item.code,
        name: item.name,
        type: item.type && item.type === 'selfDef' ? item.type : 'variable'
      };
      bodyDetail.push(obj);
    });
    this.viewTableData = [];
    this.supService.editListData(this.executionId, {ids: this.ids, bodyDetail}).subscribe( res => {
      this.viewTableData = res ? res : [];
    });
  }

  editListSubmit() {
    this.checkedEmailList = JSON.parse(JSON.stringify(this.viewHead));
    this.selfDefValue = this.viewTableData
    this.editListVisible = false;
  }

  editListCancel() {
    this.modalServer.confirm({
      nzTitle: '关闭提示',
      nzContent: '弹框关闭之后填写数据将丢失，请确认是否关闭？',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        this.editListVisible = false;
      }
    });
  }

  // 添加数据列
  addDataOprate() {
    this.addDataForm.reset();
    this.addDataVisible = true;
  }

  addDataSubmit() {
    if (this.addDataForm.get('name').value && !this.addDataForm.get('name').value.trim()) {
      this.addDataForm.get('name').patchValue('');
    }
    for (const key in this.addDataForm.controls) {
      this.addDataForm.controls[key].markAsDirty();
      this.addDataForm.controls[key].updateValueAndValidity();
    }
    if (this.addDataForm.valid) {
      const obj = {
        code: UUID.UUID().replace(/-/g, '').toLocaleUpperCase(),
        name: this.addDataForm.get('name').value,
        type: 'selfDef'
      };
      this.viewHead.push(obj);
      this.viewTableData.forEach( item => {
        item[obj.code] = '';
      })
      this.addDataCancle();
    }
  }

  addDataCancle() {
    this.addDataVisible = false;
  }

  // 邮件模板变更
  changeTemplate(event) {
    if (event) {
      this.supService.getgetEmailTemplateDetail(event).subscribe( res => {
        const data = res;
        data['emailModelText'] = this.emailTemplateList.filter( item => item.id === event)[0].name;
        this.initWarned(data);
      });
    }
  }

}
